<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.bezeichnung"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.designation') }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="verantwortlicher"
                      :person="filters.verantwortlicher"
                      label="Ersteller"
                      :allowOpen="false"
                      editable
                      @confirmed="setVerantwortlicher"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div
                      class="form-group"
                      id="number-of-records"
                    >
                      <input
                        v-model="filters.count"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.numberofrecords') }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.journalentries')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
            ></head-menu>
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    :sort-compare="sortDates"
                    sort-icon-left
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template
                      slot="top-row"
                      slot-scope="{ fields }"
                    >
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <b-input
                          v-if="
                            field.key != 'selected' && field.searchable != false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                        />
                      </td>
                    </template>
                    <template #cell(details)="row">
                      <b-button
                        @click="row.toggleDetails"
                        class="m-0"
                        variant="outline-primary"
                        size="sm"
                        v-tooltip
                        :title="
                          row.detailsShowing
                            ? 'Beschreibung verbergen'
                            : 'Beschreibung anzeigen'
                        "
                      >
                        <font-awesome-icon
                          :icon="
                            row.detailsShowing
                              ? 'fa-chevron-up'
                              : 'fa-chevron-down'
                          "
                        />
                      </b-button>
                    </template>
                    <template #row-details="row">
                      <div
                        class="mb-2"
                        v-html="
                          row.item.beschreibung || $t('global.nodescription')
                        "
                      ></div>
                    </template>
                  </b-table>

                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="(state) => infiniteHandler(state, 'app-api')"
                  >
                    <div slot="spinner">{{ $t('global.loadmoredata') }}</div>
                    <div slot="no-more">{{ $t('global.nofurtherdata') }}</div>
                    <div slot="no-results">
                      {{ $t('global.nofurtherdatafound') }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loeschen-modal
      id="aktivitaeten-loeschen-modal"
      @confirmed="loeschen"
      :multiple="true"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
  import Api from '@/api/Api'
  import HeadMenu from '@/components/HeadMenu'
  import HeadMenuFilter from '@/components/HeadMenuFilter'
  import Navbar from '@/components/Navbar'
  import LoeschenModal from '@/components/Modals/LoeschenModal'
  import store from '@/store'
  import page from '@/mixins/Page'
  import dashboard from '@/mixins/Dashboard'
  import filter from '@/mixins/Filter'
  import SingleSelectPerson from '@/components/global/SingleSelectPerson.vue'
  import FilterSearchResetButton from '@/components/Buttons/FilterSearchResetButton'

  export default {
    name: 'Journaleintraege',
    components: {
      Navbar,
      HeadMenu,
      HeadMenuFilter,
      LoeschenModal,
      SingleSelectPerson,
      FilterSearchResetButton,
    },
    metaInfo() {
      return {
        titleTemplate: () => {
          return 'BX: ' + this.$t('global.journalentries')
        },
      }
    },
    mixins: [page, dashboard, filter],
    props: {},
    store,
    data() {
      return {
        filterMitarbeitende: this.$CONST('ROLLEN').MITARBEITER,
        isDisabled: false,
      }
    },
    computed: {
      fields() {
        return [
          {
            key: 'bezeichnung',
            sortable: true,
            label: this.$t('global.designation'),
          },
          {
            key: 'datum',
            sortable: true,
            label: this.$t('global.date'),
            formatter: (value) => {
              return value ? this.formatDate(value) : '-'
            },
            searchable: false,
          },
          {
            key: 'typ.bezeichnung',
            sortable: true,
            label: this.$t('global.type'),
            searchable: false,
          },
          {
            key: 'status.bezeichnung',
            sortable: true,
            label: this.$t('global.status'),
            searchable: false,
          },
          {
            key: 'verantwortlicher.personName',
            sortable: true,
            label: this.$t('global.Responsible'),
            searchable: false,
          },
          {
            key: 'details',
            sortable: false,
            label: '',
            searchable: false,
          },
        ]
      },
      queryParams: function () {
        var params = {}

        //params.pers = this.setQueryParam(this.filters.person);
        params.verantwortlicher = this.setQueryParam(
          this.filters.verantwortlicher?.id
        )
        params.filterCount = this.setQueryParam(this.filters.count)

        params.userId = this.angemeldeterMitarbeiter.person.id
        params.isDozent = this.isDozent
        params.filterBezeichnung = this.setQueryParam(this.filters.bezeichnung)

        return params
      },
    },
    created() {
      if (
        this.gruppen.find(
          (gruppe) => gruppe.id == this.$CONST('GRUPPEN').INSTRUCTOR
        )
      )
        this.isDozent = true
      this.initFilter(
        'journaleintraege-liste',
        'bildung/dashboard-journaleintraege/',
        true
      )
    },
    mounted() {
      this.$bus.$emit('searchWithFilter')
    },
    methods: {
      details(journalEintrag) {
        this.$router.push({
          name: 'journaleintrag',
          params: { id: journalEintrag.id, anzeige: 0 },
        })
      },

      loeschen() {
        Api.delete('journal/journaleintrag/', { data: this.selectedIds }).then(
          (response) => {
            this.schliesseLoeschenModal()

            this.listData = this.listData.filter(
              (v) => !response.data.success.includes(v.id)
            )
          }
        )
      },

      formatDate(datum) {
        let date = new Date(datum)
        let day = String(date.getDate()).padStart(2, '0')
        let month = String(date.getMonth() + 1).padStart(2, '0')
        let year = date.getFullYear()

        return `${day}.${month}.${year}`
      },

      schliesseLoeschenModal() {
        $('#aktivitaet-loeschen-modal').modal('hide')
      },

      oeffneLoeschenModal() {
        $('#aktivitaet-loeschen-modal').modal('show')
      },

      setVerantwortlicher(person) {
        this.$set(this.filters, 'verantwortlicher', person)
      },

      setPerson(person) {
        this.$set(this.filters, 'person', person)
      },
    },
  }
</script>

<style></style>
